export const PLACEHOLDER = '/images/vehicle-placeholder.webp?v=4';
export const PLACEHOLDER_NEW = '/images/vehicle-placeholder-arrivage.webp?v=1';
export const coverOf = (v) => v.images?.[0] || (v.status === 'new_arrival' ? PLACEHOLDER_NEW : PLACEHOLDER);
export const GREEN = '#1a5c3b';

const SPECIAL = { BMW: 'BMW', GMC: 'GMC', KIA: 'Kia', 'MERCEDES-BENZ': 'Mercedes-Benz', RAM: 'RAM', MINI: 'Mini' };
export const normMake = (m = '') => {
  const up = m.trim().toUpperCase();
  if (SPECIAL[up]) return SPECIAL[up];
  return up.toLowerCase().replace(/(^|[\s-])\S/g, (c) => c.toUpperCase());
};
export const logoUrl = (make) => `https://www.carlogos.org/car-logos/${make.toLowerCase().replace(/\s+/g, '-')}-logo.png`;

const BODY = {
  suv: ['VUS', 'SUV'], sedan: ['Berline', 'Sedan'], hatchback: ['Hayon', 'Hatchback'], truck: ['Camion', 'Truck'],
  van: ['Fourgon', 'Van'], minivan: ['Fourgonnette', 'Minivan'], coupe: ['Coupé', 'Coupe'],
  convertible: ['Cabriolet', 'Convertible'], wagon: ['Familiale', 'Wagon'],
};
const BODY_ALIAS = { vus: 'suv', berline: 'sedan', pickup: 'truck', camion: 'truck', hayon: 'hatchback', fourgonnette: 'minivan', fourgon: 'van', familiale: 'wagon', cabriolet: 'convertible', 'coupé': 'coupe' };
export const normBody = (b) => { const k = (b || '').trim().toLowerCase(); return BODY_ALIAS[k] || k; };
export const bodyLabel = (b, en) => { const k = normBody(b); return k ? (BODY[k] || [k, k])[en ? 1 : 0] : '-'; };
export const normModel = (m = '') => m.trim().split(/\s+/).map((w) => (/\d/.test(w) || w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())).join(' ');

const DRIVE = { awd: ['Intégrale', 'AWD'], '4wd': ['4x4', '4WD'], '4x4': ['4x4', '4WD'], fwd: ['Traction avant', 'Front-wheel drive'], rwd: ['Propulsion', 'Rear-wheel drive'] };
export const driveLabel = (d, en) => (d ? (DRIVE[d.toLowerCase()] || [d.toUpperCase(), d.toUpperCase()])[en ? 1 : 0] : '-');

export const transLabel = (t, en) => {
  const k = (t || '').toLowerCase();
  if (!k || k.startsWith('auto')) return en ? 'Automatic' : 'Automatique';
  if (k === 'cvt') return 'CVT';
  if (k.startsWith('man')) return en ? 'Manual' : 'Manuelle';
  return t;
};

const FUEL = { gasoline: ['Essence', 'Gasoline'], essence: ['Essence', 'Gasoline'], diesel: ['Diesel', 'Diesel'], electric: ['Électrique', 'Electric'], hybrid: ['Hybride', 'Hybrid'] };
export const fuelLabel = (f, en) => (f ? (FUEL[f.toLowerCase()] || [f, f])[en ? 1 : 0] : '-');

export const fmtPrice = (p, en) => {
  const n = Math.round(Number(p) || 0);
  if (!n) return null;
  return new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
};
export const fmtKm = (k, en) => `${new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA').format(Number(k) || 0)} km`;

export const PRICE_MAX = [15000, 20000, 25000, 30000, 40000, 50000];
export const KM_MAX = [50000, 75000, 100000, 125000, 150000];

export const SORTS = [
  { v: 'created_at-desc', fr: 'Recommandé', en: 'Recommended' },
  { v: 'price-asc', fr: 'Prix : bas à élevé', en: 'Price: low to high' },
  { v: 'price-desc', fr: 'Prix : élevé à bas', en: 'Price: high to low' },
  { v: 'year-desc', fr: 'Année : récent à ancien', en: 'Year: new to old' },
  { v: 'mileage-asc', fr: 'Kilométrage : bas à élevé', en: 'Mileage: low to high' },
];

const num = (x) => (typeof x === 'string' && Number.isNaN(Number(x)) ? x : Number(x) || 0);
export const sortVehicles = (list, sort) => {
  const [field, order] = sort.split('-');
  return [...list].sort((a, b) => {
    const av = num(a[field]);
    const bv = num(b[field]);
    if (av === bv) return 0;
    return order === 'asc' ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
  });
};

export const EMPTY_FILTERS = { q: '', makes: [], models: [], bodies: [], maxPrice: 0, maxKm: 0 };

export const filterVehicles = (list, f) => {
  const q = f.q.trim().toLowerCase();
  return list.filter((v) => {
    if (f.makes.length && !f.makes.includes(normMake(v.make))) return false;
    if (f.models.length && !f.models.includes(normModel(v.model))) return false;
    if (f.bodies.length && !f.bodies.includes(normBody(v.body_type))) return false;
    if (f.maxPrice && Number(v.price) > f.maxPrice) return false;
    if (f.maxKm && Number(v.mileage) > f.maxKm) return false;
    if (q) {
      const vin = (v.vin || '').toLowerCase();
      const hay = `${v.year} ${v.make} ${v.model} ${v.trim || ''}`.toLowerCase();
      const ok = hay.includes(q) || (v.stock_number || '').toLowerCase().includes(q) || vin.includes(q) || q.split(/\s+/).every((w) => hay.includes(w));
      if (!ok) return false;
    }
    return true;
  });
};

export const countBy = (list, fn) => {
  const m = {};
  list.forEach((v) => { const k = fn(v); if (k) m[k] = (m[k] || 0) + 1; });
  return Object.entries(m).sort((a, b) => b[1] - a[1]);
};

const PROMO_SLOTS = [6, 11, 19];
export const buildGrid = (vehicles, promos) => {
  const items = [];
  let vi = 0;
  let pi = 0;
  while (vi < vehicles.length) {
    const pos = items.length % 21;
    if (PROMO_SLOTS.includes(pos) && promos.length) {
      items.push({ type: 'promo', data: promos[pi % promos.length], key: `promo-${items.length}` });
      pi += 1;
    } else {
      items.push({ type: 'vehicle', data: vehicles[vi], key: vehicles[vi].id });
      vi += 1;
    }
  }
  return items;
};
